import gql from 'graphql-tag';

export const GET_PORTAL_NOTIFICATIONS_STATUS = gql`
  query GetPortalNotificationsStatus {
    broadcast {
      portalNotificationsStatus {
        unreadCount
      }
    }
  }
`;
